import { Component, OnInit } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faUsers, faCity } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-edit-delete-renderer',
  templateUrl: './edit-delete-renderer.component.html',
  styleUrls: ['./edit-delete-renderer.component.scss']
,
  standalone: false
})
export class EditDeleteRendererComponent implements OnInit, ICellRendererAngularComp {
  faUsers = faUsers;
  faCity = faCity;

  constructor() { }

  params: any;
  data: any;
  icons: IconDefinition[]; // ✨ if wanting just the 1 icon change to `IconDefinition`

  agInit(params: any): void {
    this.params = params;
    this.data = this.params.data;
  }

  refresh(): boolean {
    return false;
  }
  ngOnInit(): void {
  }

  onEdit(value:string){
    this.params.onEdit(value);
  }

  onEditClick(id: any) {
    this.params.onEditClick(id);
  }

  onDeleteClick(id: any) {
    this.params.onDeleteClick(id);
  }
}
